define.alias("shared/components/shared/post/sandbox", "calendar/components/shared/post/sandbox");